module.exports = __webpack_public_path__ + "buildingstore.jpg?55eafa3f1febca2c94f41d128317d582";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/buildingstore.jpg
// module id = 107
// module chunks = 0